/**
 * NOT CHECKED
 */
import React, { useEffect, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';

import { SVGIcon } from '@uikit/old/Icon/Icon';
import DateRangePickerWrapper from '@uikit/old/DateRangePicker/DateRangePicker';
import {
  transformDateToString,
  dateRangeNumberFormatToString,
} from '@helpers/dateTimeRangeHelpers';
import { DateRangeDateType, DateRangeNumberType } from '@ts/common.types';

import './HeaderDateFilter.scss';

const HeaderDateFilter = ({
  value,
  onChangeDatarange,
  additionalClassname,
  isRangePicker = true,
  id = '',
  skipDayCheck = false,
  placeholder,
  onClear,
}: {
  value: DateRangeNumberType | null;
  onChangeDatarange: (selection: DateRangeDateType) => void;
  additionalClassname?: string;
  isRangePicker?: boolean;
  id?: string;
  skipDayCheck?: boolean;
  /** Shown while no range is selected (e.g. "All time"). */
  placeholder?: string;
  /** When provided, a clear control resets the filter to "no range". */
  onClear?: () => void;
}): JSX.Element => {
  const [dateRange, changeDateRange] = useState(dateRangeNumberFormatToString(value));
  const tooltipButtonRef = useRef();
  const tooltipWrapperRef = useRef();

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    changeDateRange(null);
    onClear();
  };

  // TODO: it breaks "filter" tooltip on LeaderBoards and CampaignPerformance pages
  // useOutsideClick(tooltipWrapperRef, () => ReactTooltip.hide(tooltipButtonRef.current));

  const handleSingleDateSelect = (date) => {
    changeDateRange(transformDateToString(date));
    onChangeDatarange({ startDate: date, endDate: date });
  };

  const handleSelectDaterange = ({ selection }: { selection: DateRangeDateType }) => {
    const startDate = transformDateToString(selection.startDate);
    const endDate = transformDateToString(selection.endDate);

    changeDateRange(`${startDate} - ${endDate}`);
    onChangeDatarange(selection);
  };

  useEffect(() => {
    if (dateRange === null && !!value?.startDate) {
      changeDateRange(dateRangeNumberFormatToString(value));
    }
  }, [value, dateRange]);

  return (
    <div ref={tooltipWrapperRef}>
      <div
        className={`header-date-filter ${additionalClassname}`}
        data-for={`header-date-filter-tooltip--${id}`}
        data-tip=""
        data-event="click"
        role="button"
        tabIndex={0}
      >
        {dateRange ?? placeholder}
        {dateRange && onClear ? (
          <button
            type="button"
            className="header-date-filter__clear"
            aria-label="Clear date filter"
            onClick={handleClear}
          >
            <SVGIcon icon="close" color="hsl(0, 0%, 60%)" size={12} />
          </button>
        ) : (
          <SVGIcon icon="chevron" color="hsl(0, 0%, 80%)" />
        )}
      </div>
      <ReactTooltip
        className="react-tooltip react-tooltip--header-date-filter"
        id={`header-date-filter-tooltip--${id}`}
        place="bottom"
        effect="solid"
        event="off"
        globalEventOff="click"
        offset={{ left: 100 }}
        arrowColor="transparent"
        clickable
      >
        <DateRangePickerWrapper
          value={value}
          isRangePicker={isRangePicker}
          handleSelect={isRangePicker ? handleSelectDaterange : handleSingleDateSelect}
          skipDayCheck={skipDayCheck}
        />
      </ReactTooltip>
    </div>
  );
};

export default HeaderDateFilter;
